import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_CALL_INSIGHT_STATE,
});

export const setFilters = (startDate, endDate, filters) => ({
  type: types.SET_CALL_INSIGHT_FILTERS.REQUEST,
  startDate,
  endDate,
  filters,
});

export const setFiltersSuccess = (startDate, endDate, filters) => ({
  type: types.SET_CALL_INSIGHT_FILTERS.SUCCESS,
  startDate,
  endDate,
  filters,
});

export const setFiltersFailure = (error) => ({
  type: types.SET_CALL_INSIGHT_FILTERS.FAILURE,
  error,
});
